import gql from "graphql-tag";

export const updateKnowledgeBaseSectionMutation = gql`
  mutation updateKnowledgeBaseSection($id: ID!, $name: String!) {
    updateKnowledgeBaseSection(id: $id, name: $name) {
      id
    }
  }
`;
